









































import {Component, Prop, Vue} from 'vue-property-decorator'
import {$} from 'simpli-web-sdk'
import {Dialog} from '@/helpers/dialog/Dialog'

@Component
export default class ModalDialog extends Vue {
  options: Dialog | null = null

  openEvent(payload?: Dialog) {
    this.$emit('open')

    this.options = payload ?? null
  }

  closeEvent() {
    this.options = null
    this.$emit('close')
  }

  async confirmEvent() {
    this.$emit('confirm')
    await $.await.run('processing', () => this.options?.onConfirm())
    this.close()
  }

  async cancelEvent() {
    this.$emit('cancel')
    await $.await.run('processing', () => this.options?.onCancel())
    this.close()
  }

  close() {
    this.$modal.close('dialog')
  }
}
